module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-modal"
  }, [_c('div', {
    staticClass: "m-modal__inner"
  }, [_c('h1', {
    staticClass: "m-modal__inner__title"
  }, [_vm._t("title", [_vm._v("タイトル")])], 2), _vm._v(" "), _c('div', {
    staticClass: "m-modal__inner__content"
  }, [_vm._t("body", [_vm._v("コンテンツ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "m-modal__inner__bottom"
  }, [_vm._t("footer", [_vm._v("下部")])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59d6c230"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/History/History.vue
// module id = 1382
// module chunks = 0